import { images } from "@/data/resort";
import { useBooking } from "../booking-context";
import { ResortButton, ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";
import { SiteFeatureList } from "./SiteFeatureList";

const features = [
  "Gravel parking pad",
  "20 / 30 / 50 amp hookups",
  "Water",
  "Sewer",
  "Complimentary WiFi",
  "Picnic table",
] as const;

export function BackInSites() {
  const { openBooking } = useBooking();

  return (
    <section
      id="back-in"
      aria-labelledby="back-in-heading"
      className="scroll-mt-16 bg-secondary/45 py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Settle In &amp; Stay Awhile</Eyebrow>
            </Reveal>
            <h2 id="back-in-heading" className="display-lg mt-6">
              <MaskReveal>Back-In RV Sites</MaskReveal>
            </h2>

            <Reveal delay={0.1}>
              <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground">
                <p>
                  Back-in sites are available for guests who do not require a pull-through space and
                  offer a wide range of site lengths for everything from compact RVs to larger rigs.
                </p>
                <p>
                  Sites range from approximately 36 feet to more than 120 feet in length. Back-in
                  sites are available for daily, weekly and monthly stays.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.14}>
              <div className="mt-10">
                <p className="eyebrow text-muted-foreground">Site Lengths</p>
                <p className="font-display mt-2 text-4xl tracking-tight text-primary md:text-5xl">
                  36′ – 120′+
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.16}>
              <SiteFeatureList features={features} />
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortButton variant="solid" onClick={openBooking} className="w-full sm:w-auto">
                  Check Back-In Availability
                </ResortButton>
                <ResortLink variant="outline" href="/amenities/" className="w-full sm:w-auto">
                  Explore Amenities
                </ResortLink>
              </div>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-6" y={36}>
            <img
              src={images.siteBackin}
              alt="Aerial view of back-in RV sites and landscaped grounds at Auburn RV Resort"
              width={1400}
              height={1600}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover md:aspect-[5/6]"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
